module.exports = __webpack_public_path__ + "images/company/rank_medal/selling_agreement_percent_rank/5_6074a02505a97053dd1f95153f556564.png";